import { Flex } from '#atoms';
import { TimePickerInput } from 'src/components/atoms/TimePickerInput';
import styled from 'styled-components';

type TimePeriodProps = {
  hasDeletedIcon?: boolean;
  startAt?: Date;
  endAt?: Date;
  onRemove?: () => void;
  onChangeStartAt?: (date: Date) => void;
  onChangeEndAt?: (date: Date) => void;
};

export default function TimePeriod({
  hasDeletedIcon,
  startAt,
  onChangeStartAt,
  endAt,
  onChangeEndAt,
  onRemove
}: TimePeriodProps) {
  return (
    <Flex gap={8} align="center">
      <TimePickerInput
        title="시작 시간 선택"
        fullWidth
        date={startAt}
        onChange={onChangeStartAt}
        minuteStep={30}
      />
      <Between>~</Between>
      <TimePickerInput
        title="종료 시간 선택"
        fullWidth
        date={endAt}
        onChange={onChangeEndAt}
        minuteStep={30}
      />
      <IconWrapper onClick={onRemove}>
        {hasDeletedIcon ? <TrashIcon /> : <Empty />}
      </IconWrapper>
    </Flex>
  );
}

const Between = styled.span`
  color: ${({ theme }) => theme.palette.gray15};
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 1.5px 3px;
  margin-right: 8px;
  cursor: pointer;
`;

const Empty = styled.div`
  width: 14px;
`;

const TrashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
  >
    <g clipPath="url(#clip0_65_1917)">
      <path
        d="M8.76051 1.7115L9.65576 1.70975L9.65376 0.946754C9.65376 0.828754 9.60576 0.713754 9.52226 0.630504C9.43926 0.547254 9.32326 0.499504 9.20551 0.500004L4.79001 0.509504C4.67176 0.510254 4.55701 0.557504 4.47376 0.641254C4.39001 0.724754 4.34326 0.840254 4.34326 0.958254L4.34476 1.721L5.24051 1.719L5.23951 1.40375L8.75951 1.39625L8.76051 1.7115Z"
        fill="#4D495A"
      />
      <path
        d="M0.0035 4.1286L14 4.09835L13.9965 2.67285L12.645 2.6756L12.643 1.9256C12.643 1.8671 12.619 1.80985 12.5778 1.76885C12.5365 1.72735 12.479 1.7041 12.4205 1.7041L9.6555 1.7101L8.76025 1.71185L5.24025 1.7196L4.3445 1.7216L1.57625 1.7276C1.5175 1.7276 1.4605 1.7516 1.4195 1.79335C1.37825 1.8346 1.3545 1.89185 1.3545 1.9501L1.3565 2.7006L0 2.7036L0.0035 4.1291V4.1286Z"
        fill="#4D495A"
      />
      <path
        d="M0.751709 4.53809V16.5231H13.2485V4.53809H0.751709ZM4.15546 15.3963C4.15546 15.4528 4.13396 15.5061 4.09396 15.5463C4.05346 15.5863 4.00046 15.6083 3.94371 15.6083H2.71121C2.65496 15.6083 2.60096 15.5858 2.56121 15.5463C2.52171 15.5068 2.49871 15.4521 2.49871 15.3963V6.01009C2.49871 5.95409 2.52146 5.89934 2.56121 5.85984C2.60046 5.82034 2.65521 5.79759 2.71121 5.79759H3.94371C3.99971 5.79759 4.05446 5.82034 4.09396 5.85984C4.13346 5.89934 4.15546 5.95409 4.15546 6.01009V15.3963ZM7.82846 15.3963C7.82846 15.4033 7.82821 15.4103 7.82746 15.4173C7.82271 15.4661 7.80121 15.5111 7.76621 15.5463C7.72571 15.5863 7.67246 15.6083 7.61596 15.6083H6.38346C6.32771 15.6083 6.27346 15.5858 6.23321 15.5463C6.19371 15.5068 6.17096 15.4521 6.17096 15.3963V6.01009C6.17096 6.00309 6.17121 5.99609 6.17196 5.98909C6.17671 5.94059 6.19846 5.89434 6.23296 5.85984C6.27246 5.82034 6.32721 5.79759 6.38296 5.79759H7.61546C7.62246 5.79759 7.62921 5.79784 7.63621 5.79859C7.68321 5.80334 7.72821 5.82409 7.76246 5.85684C7.76346 5.85784 7.76446 5.85859 7.76546 5.85959C7.80496 5.89909 7.82771 5.95384 7.82771 6.00984V15.3961L7.82846 15.3963ZM11.5012 15.3963C11.5012 15.4528 11.479 15.5061 11.4385 15.5463C11.3985 15.5863 11.3455 15.6083 11.2887 15.6083H10.0562C10.0005 15.6083 9.94571 15.5858 9.90596 15.5463C9.86646 15.5068 9.84371 15.4521 9.84371 15.3963V6.01009C9.84371 5.95409 9.86646 5.89934 9.90596 5.85984C9.94546 5.82059 9.99996 5.79759 10.056 5.79759H11.2885C11.3447 5.79759 11.3992 5.82034 11.4382 5.85984C11.478 5.89934 11.501 5.95409 11.501 6.01009V15.3963H11.5012Z"
        fill="#4D495A"
      />
    </g>
    <defs>
      <clipPath id="clip0_65_1917">
        <rect
          width="14"
          height="16.0238"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
